import { Property } from "./interfaces";

export const numDocumentoIdentificacion: Property = {
    title: "Número de Documento de Identificación",
    type: "string"
}